'use client';
import * as Styled from './styled';
import { ICommit } from '@/types';
import Input from '@/components/Input';
import { toLocalTimeAgo } from '@/lib/dateTime';

import { IFileVersion } from '@/lib/tabularFileApi';
import { Row } from '@/ui/primatives';
import * as Icon from '@/ui/Icon';

const CommitOption: React.FC<{ commit: ICommit }> = ({ commit }) => (
  <Styled.CommitOption>
    <Row gap={20} justifyContent="space-between">
      <div className="commitRef">{commit.id}</div>
      <div className="commit-date">
        {commit.timestamp !== 'EVERGREEN' ? (
          <span>
            {toLocalTimeAgo(commit.timestamp)} by {commit.author || commit.email}
          </span>
        ) : (
          'Current'
        )}
      </div>
    </Row>
    <div className="commit-message">
      <div>{commit.message}</div>
    </div>
  </Styled.CommitOption>
);

const CustomOption = (props: any) => {
  const { innerProps, isDisabled, data, getStyles } = props;
  const commit: ICommit = data.commit;
  return !isDisabled ? (
    <div style={getStyles('option', props)} {...innerProps}>
      <CommitOption commit={commit} />
    </div>
  ) : null;
};

const VersionSelect: React.FC<{
  versions: IFileVersion[];
  selectedVersion?: IFileVersion;
  placeholder: string;
  onChange: (version: IFileVersion | undefined) => void;
}> = ({ versions, selectedVersion, placeholder, onChange }) => {
  const versionOptions = versions.map((version) => ({
    value: version.commit.id,
    label: version?.commit.id,
    commit: version.commit,
  }));

  return (
    <>
      <Input.SelectControl
        name="file-version"
        wide
        placeholder={placeholder}
        disabled={versions.length < 1}
        options={versionOptions}
        selectedValue={selectedVersion?.commit.id}
        onChange={(v) => onChange(versions.find((version) => version?.commit?.id === v))}
        isSearchable={false}
        customComponents={{ Option: CustomOption }}
        prefixElement={<Icon.Clock className="prefix-icon" />}
        styles={{
          option: (styles, state) => ({
            ...styles,
            whiteSpace: 'nowrap',
          }),
        }}
      ></Input.SelectControl>
    </>
  );
};

export default VersionSelect;
